import { render, staticRenderFns } from "./VimeoEmbed.vue?vue&type=template&id=59d49d04&scoped=true"
import script from "./VimeoEmbed.vue?vue&type=script&lang=js"
export * from "./VimeoEmbed.vue?vue&type=script&lang=js"
import style0 from "./VimeoEmbed.vue?vue&type=style&index=0&id=59d49d04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d49d04",
  null
  
)

export default component.exports